import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

import { setModoTela, initForm } from './unidadeActions';
import consts from '../consts';
import { setError } from '../common/toast/toast';
import imagemAdd from '../assets/images/icone_add_imagem.png';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';

class UnidadeForm extends Component {

    componentWillMount() {

		let initSeletorArquivo = () => {
			const fileSelectorArquivo = document.createElement('input');
			fileSelectorArquivo.setAttribute('type', 'file');
			fileSelectorArquivo.addEventListener("change", (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('application/pdf')
						&& !file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PDF, .PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {


						let lista = (this.props.formularioValues.documentos || []).map(item => item);
						lista.push({
							arquivo_base64: reader.result
						});

						this.props.initForm({
							...this.props.formularioValues,
							documentos: lista
						});

						initSeletorArquivo();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorArquivo = fileSelectorArquivo;
		};

		initSeletorArquivo();

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='quadra'
								component={LabelAndInput}
								label='Quadra *' placeholder='Informe a quadra'
								cols='12 4 3 2'
								readOnly={'readOnly'} />

							<Field
								name='numero'
								component={LabelAndInput}
								label='Número *' placeholder='Informe o número'
								cols='12 4 3 2'
								readOnly={'readOnly'} />
							
							<Field
								name='matricula'
								component={LabelAndInput}
								label='Matrícula *' placeholder='Informe o número'
								cols='12 4 3 2'
								readOnly={readOnly} />

							<Field
								name='descricao'
								component={LabelAndInput}
								label='Descrição *' placeholder='Informe a descrição'
								cols='12 12 9 10'
								readOnly={readOnly} />

							<Field
								name='leste'
								component={LabelAndInputNumber}
								label='Leste' placeholder='Informe'
								cols='12 6 3 3'
								casas={4}
								readOnly={readOnly} />

							<Field
								name='oeste'
								component={LabelAndInputNumber}
								label='Oeste' placeholder='Informe'
								cols='12 6 3 3'
								casas={4}
								readOnly={readOnly} />
							
							<Field
								name='norte'
								component={LabelAndInputNumber}
								label='Norte' placeholder='Informe'
								cols='12 6 3 3'
								casas={4}
								readOnly={readOnly} />
							
							<Field
								name='sul'
								component={LabelAndInputNumber}
								label='Sul' placeholder='Informe'
								cols='12 6 3 3'
								casas={4}
								readOnly={readOnly} />

							<Field
								name='area_privativa'
								component={LabelAndInputNumber}
								label='Área Privativa' placeholder='Informe'
								cols='12 6 3 3'
								casas={4}
								readOnly={readOnly} />

							<Field
								name='area_total'
								component={LabelAndInputNumber}
								label='Área Total' placeholder='Informe'
								cols='12 6 3 3'
								casas={4}
								readOnly={readOnly} />
							
							<Field
								name='preco_avista'
								component={LabelAndInputNumber}
								label='Preço (À Vista)' placeholder='Informe o preço'
								cols='12 6 3 3'
								casas={2}
								readOnly={readOnly} />
							
							{/*<Field
								name='preco_prazo'
								component={LabelAndInputNumber}
								label='Preço (A Prazo)' placeholder='Informe o preço'
								cols='12 6 3 3'
								casas={2}
								readOnly={readOnly} />*/}
						</Row>

						<Row>
							<Grid cols='12 12 12 12'>

								<Row style={{ paddingBottom: 16 }}>
									<Grid cols='12 12 12 12'>
										<label>Anexos</label>
									</Grid>
									<div style={{ marginLeft: 16, display: 'flex' }}>
										{(this.props.formularioValues.documentos || []).map(arquivo => (
											<div style={{ display: 'flex', flexDirection: 'column', marginRight: 8 }}>
												<span class="btn btn-outline-primary fileinput-button dz-clickable">
													<img src={arquivo.arquivo_base64 ? pdfAdicionado : (arquivo.arquivo ? pdfAdicionado : pdfAdd)} style={{ height: 30 }} />
												</span>
												<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
													<button
														type='button'
														class='btn btn-flat btn-outline-primary'
														style={{ width: '48%' }}
														disabled={arquivo.arquivo_base64 ?true : false}
														onClick={() => {
															window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
														}}>
														<i class='fas fa-download'></i>
													</button>

													<button
														type='button'
														class='btn btn-flat btn-outline-danger'
														style={{ width: '48%' }}
														disabled={readOnly}
														onClick={() => {
															this.props.initForm({
																...this.props.formularioValues,
																documentos: this.props.formularioValues.documentos.filter(item => item != arquivo)
															});
														}}>
														<i class='fas fa-trash-alt'></i>
													</button>
												</div>
											</div>
										))}
										{!readOnly ? (
											<span class="btn btn-outline-primary fileinput-button dz-clickable" onClick={() => this.fileSelectorArquivo.click()}>
												<img src={pdfAdd} style={{ height: 30 }} />
											</span>
										) : null}
									</div>
								</Row>

							</Grid>
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

UnidadeForm = reduxForm({form: 'unidadeForm', destroyOnUnmount: false})(UnidadeForm);
const mapStateToProps = state => ({
	sessao: state.auth.unidade,
	formularioValues: getFormValues('unidadeForm')(state),
	registro: state.unidade.registro,
	listaRegiao: state.unidade.listaRegiao,
	listaLocalEstoque: state.unidade.listaLocalEstoque
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UnidadeForm);
